import { Link, useParams } from 'react-router';

import type { ProductVariantCardFragment } from '@boc/framework/saleor-graphql';

import { TwPicture } from '@boc/images';

import { Price } from '~/local/components/price';
import { imgUrl, urls } from '~/urls';
import { getVariantUrl, getVariantDisplayName } from '~/local/products/variant-url';

function VariantCompactCard({ variant }: { variant: ProductVariantCardFragment }) {
  const params = useParams();
  const baseUrl = urls.products.details(params, { slug: variant.product.slug });
  const detailsUrl = getVariantUrl(variant, baseUrl);

  const imageUrl = variant.media?.[0]?.url || variant.product.thumbnail?.url;
  const imageAlt = variant.media?.[0]?.alt || variant.product.thumbnail?.alt || variant.name;

  return (
    <Link
      to={detailsUrl}
      key={variant.id}
      className="flex flex-col gap-6"
    >
      <div className="h-40 w-full">
        {imageUrl && (
          <TwPicture
            imgUrl={imgUrl}
            src={imageUrl}
            defaultSize={141}
            alt={imageAlt}
            className="h-full w-full object-contain mix-blend-multiply"
          />
        )}
      </div>
      <div className="w-full truncate text-center font-heading text-medium leading-5 tracking-tight text-primary-2-80">
        <h4 className="">{getVariantDisplayName(variant)}</h4>
        <div className="">
          {variant.pricing?.onSale ? (
            <Price
              price={variant.pricing?.priceUndiscounted?.gross}
              className="block line-through"
            />
          ) : (
            <></>
          )}
          <Price price={variant.pricing?.price?.gross} />
        </div>
      </div>
    </Link>
  );
}

export default VariantCompactCard;
